import { defineMessages } from 'react-intl';

/**
 * An artist above the artist limit of the plan (a plan went down, pricing spec 2026-10-08 §4): the
 * app shows its data, but a change answers 403 `M24_LIMIT_ARTIST_READ_ONLY`.
 */
export const readOnlyArtistMessages = defineMessages({
  tag: { id: 'app.sml.artistSwitcher.readOnly.tag', defaultMessage: 'Read-only' },
  notice: {
    id: 'app.sml.artistSwitcher.readOnly.notice',
    defaultMessage: 'This artist is read-only on your plan. Add an artist to edit it.',
  },
  action: { id: 'app.sml.artistSwitcher.readOnly.action', defaultMessage: 'Add an artist' },
});
